export default "__VITE_ASSET__DoXCanVd__"